// extracted by mini-css-extract-plugin
export default {"item":"MenuGroup_item__F5zQv","container":"MenuGroup_container__BmEEV","selected":"MenuGroup_selected__lvGo9"};